import { Injectable } from '@angular/core';
import { PushService } from 'rev-shared/push/PushService';

@Injectable({
	providedIn: 'root'
})
export class SharedWebcastService {

	constructor(
		private readonly PushService: PushService,
	) {}

	public dispatchStartWebcast(webcastId: string, runNumber: number): Promise<any> {
		return this.PushService.dispatchCommand('scheduledEvents:StartWebcast', {
			webcastId, runNumber
		}, ['VBrickDeviceStartProgramActionAdded', 'LiveEnrichmentStarting', 'WebcastStarted', 'WebcastEventAdminReconnected', 'VcStarting', 'RtmpsLiveStreamToRevStarted', 'VodStreamInitializing']);
	}
}
